import { useRef, useState } from 'react';
import { supportFetch as fetch } from '../lib/supportTransport';

const API = process.env.REACT_APP_BACKEND_URL;

export const SupportEmailForm = ({ sessionId, onCancel, onSent }) => {
  const requestId = useRef(crypto.randomUUID());
  const attempted = useRef(false);
  const [form, setForm] = useState({ name: '', email: '', message: '', website: '' });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const change = key => event => {
    if (attempted.current) { requestId.current = crypto.randomUUID(); attempted.current = false; }
    setForm(value => ({ ...value, [key]: event.target.value }));
  };
  const submit = async event => {
    event.preventDefault();
    if (sending) return;
    attempted.current = true;
    setSending(true); setError('');
    try {
      const response = await fetch(`${API}/api/support-chat/email`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, session_id: sessionId, request_id: requestId.current }),
      });
      const data = await response.json();
      if (!response.ok || !data.sent) throw new Error(typeof data.detail === 'string' ? data.detail : 'Please check your details and try again.');
      onSent();
    } catch (e) { setError(e.message || 'Email could not be sent. Please try again.'); }
    finally { setSending(false); }
  };
  const fieldClass = 'w-full rounded border border-zinc-600 bg-zinc-950 px-2.5 py-2 text-sm text-white';
  return <form onSubmit={submit} className="space-y-3 rounded-lg border border-[#C9A962]/50 bg-zinc-900 p-3" data-testid="support-email-form">
    <h3 className="text-sm font-bold text-[#C9A962]" data-testid="support-email-heading">Email support</h3>
    <label className="block text-xs text-zinc-300">Name<input required maxLength={100} value={form.name} onChange={change('name')} autoComplete="name" className={fieldClass} data-testid="support-email-name" /></label>
    <label className="block text-xs text-zinc-300">Your email<input type="email" required maxLength={254} value={form.email} onChange={change('email')} autoComplete="email" className={fieldClass} data-testid="support-email-address" /></label>
    <label className="block text-xs text-zinc-300">Message<textarea required maxLength={6000} rows={4} value={form.message} onChange={change('message')} className={fieldClass} data-testid="support-email-message" /></label>
    <input type="text" className="hidden" tabIndex={-1} aria-hidden="true" autoComplete="off" value={form.website} onChange={change('website')} data-testid="support-email-honeypot" />
    {error && <p role="alert" className="text-xs text-red-300" data-testid="support-email-error">{error}</p>}
    <div className="flex gap-2">
      <button type="button" disabled={sending} onClick={onCancel} className="rounded border border-zinc-600 px-3 py-2 text-xs text-zinc-200" data-testid="support-email-cancel">Cancel</button>
      <button type="submit" disabled={sending} className="flex-1 rounded bg-[#C9A962] px-3 py-2 text-xs font-bold text-black disabled:opacity-50" data-testid="support-email-submit">{sending ? 'Sending…' : 'Send to support'}</button>
    </div>
  </form>;
};